/* @flow */

import React, { Component } from 'react';

function formatName(options) {
  options = options || {};
  var names = [];

  if (options.firstName && !options.firstName.trim().isEmpty()) {
    var firstName = options.firstName.trim().toTitleCase();
    if (firstName.indexOf(". ") !== -1) {
      firstName = firstName.replace(". ", ".");
    }
    if (firstName.indexOf("-") !== -1) {
      var firstNames = firstName.split("-");
      firstName = firstNames[0] + "-" + firstNames[1].toLowerCase();
    }
    names.push(firstName);
  }

  // last name
  if (options.lastName && !options.lastName.trim().isEmpty()) {
    names.push(options.lastName.trim().toUpperCase());
  }

  return names.join(" ");
}


class Speaker extends Component {
  render() {
    var speaker = this.props.speaker;
    var fullName = formatName(speaker);
    var speakerId = this.props.speakerId;
    if (speakerId === speaker.id) {
      return (
        <option selected value={speaker.id}>{fullName}</option>
      );
    } else {
      return (
        <option value={speaker.id}>{fullName}</option>
      );
    }
  }
}

export default class SpeakerList extends Component {
  onChange(e) {
    this.props.onClick(e.currentTarget.value);
  }
  render() {
    var speakerId = this.props.speakerId;
    var speakerList = this.props.speakers.map(function (speaker) {
      return <Speaker key={speaker.id} speakerId={speakerId} speaker={speaker} />;
    });
    return (
      <div className="SpeakerList">
        <div className="header">Search Schedule by Speaker Name</div>
        <div className="content">
          <select name="speakerList" onChange={this.onChange.bind(this)}>
            <option></option>
            {speakerList}
          </select>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/speakerList.js
 **/